exports.map = require('rxjs/internal/operators/map').map



// WEBPACK FOOTER //
// ../node_modules/@sanity/observable/operators/map.js